import Share from 'ninelines-sharing';

const shareImagesParams = {
	vk: 'image',
	ok: 'imageUrl',
};

const socialInit = () => {
	const list = document.querySelectorAll('[data-social]');

	if (!list.length) {
		return;
	}

	Array.prototype.forEach.call(list, (item) => {
		item.addEventListener('click', (e) => {
			const social = e.currentTarget.dataset.social;
			const url = location.origin + location.pathname + location.search;

			if (social === 'vk' || social === 'ok') {
				Share.openWindow(`${Share.getUrl(social, url)}&${shareImagesParams[social]}=https://tass-feminizm.linestest.com/images/${social}.jpg`, null);
			} else if (social === 'wa') {
				window.open(`whatsapp://send?text=${encodeURIComponent(url)}`);
			} else {
				Share[social](url);
			}
		});
	});
};

export {socialInit};